<template>
  <div class="container">
    <div class="clearfix">
      <Button type="primary" @click="addEdit(0)" class="fr ml24">添加活动</Button>
    </div>
    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <Modal
      v-model="modalVisibile"
      width="524"
      :mask-closable="false"
      :title="modalTitle"
      @on-cancel="handleCancel"
    >
      <Form
        @submit.native.prevent
        ref="modalForm"
        :model="modalForm"
        :rules="modalRule"
        label-position="top"
      >
        <div class="clearfix mb32">
          <FormItem label="活动名称" prop="activity_name">
            <Input v-model="modalForm.activity_name" class="w400" placeholder="请输入活动名称"></Input>
          </FormItem>
          <FormItem label="时间范围:" class="mytable-title w400 mt24">
            <Date-picker
             :options="options"
              type="datetimerange"
              placeholder="选择日期和时间"
              class="w400"
              @on-change="handleDateChange"
              v-model="date"
            ></Date-picker>
          </FormItem>
          <FormItem label="积分倍数" class="w400 mt24" prop="integral_times">
            <Input placeholder="请输入积分倍数" v-model="modalForm.integral_times" class="w400"></Input>
          </FormItem>
          <FormItem label="活动范围" prop="use_range" class="mt24">
            <Select class="w400" v-model.trim="modalForm.activity_range">
              <Option value="3">全部</Option>
              <Option value="1">购买文章</Option>
              <Option value="2">充值</Option>
            </Select>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button :loading="modalLoading" type="primary" @click="handleModalSubmit">确定</Button>
      </div>
    </Modal>
    <!-- 设置倒计时 -->
    <!-- <Modal
      v-model="modalVisibileTime"
      width="576"
      :mask-closable="false"
      title="活动倒计时"
      @on-cancel="handleCancel"
    >
      <Form ref="modalFormTime" :model="modalFormTime" label-position="top">
        <FormItem label="日期范围:" class="mytable-title">
          <Date-picker
            type="datetimerange"
            placeholder="选择日期和时间"
            class="w240"
            @on-change="handleDateChange"
            v-model="date"
          ></Date-picker>
        </FormItem>
        <FormItem label="活动结束后/未开始文案:" class="mytable-title mt24">
          <Input
            v-model="modalFormTime.title"
            style="width: 512px;"
            type="textarea"
            placeholder="请输入文案(最多可输入25个字)"
            :maxlength="25"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisibileTime = false">取消</Button>
        <Button :loading="modalLoading" type="primary" @click="handleModalSubmit_time">确定</Button>
      </div>
    </Modal>-->
  </div>
</template>

<script>
import { getCookie } from "../../libs/util";
import mixins from "@/mixins/page";
import * as qiniu from "qiniu-js";
export default {
  mixins: [mixins],
  name: "integral_edit",
  data() {
    const validateBasket = (rule, value, callback) => {
      let reg = /\d+/g;
      if (value && value.length === 7 && !reg.test(value)) {
        callback(new Error("7个汉字时不能全为中文哦!"));
      } else {
        callback();
      }
    };
    // 校验确认密码是否与密码一致
    const validateConfirmPass = (rule, value, callback) => {
      if (value !== this.modalForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
       options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      date: [],
      activity_start_time: "",
      activity_end_time: "",
      modalVisibileTime: false,
      curStartTime: "2020-01-05 18:00:00",
      day: "0",
      hour: "00",
      min: "00",
      second: "00",
      modalFormTime: {
        title: ""
      },
      imgSrc: "",
      authorId: "",
      formData: {},
      formData1: {},
      modalForm: {
        activity_range: "3",
        integral_times: "",
        start_time: "",
        end_time: ""
      },
      modalForm1: {
        activity_range: "3",
        integral_times: "",
        start_time: "",
        end_time: ""
      },
      authorModalTitle: "",
      tableLoading: false,
      modalTitle: "添加作者",
      modalVisibile: false,
      tableData: [],
      modalLoading: false,
      modalRule: {
        activity_name: [
          { required: true, message: "请输入活动名称", trigger: "blur" }
        ],
        integral_times: [
          { required: true, message: "请输入积分倍数", trigger: "blur" }
        ]
        // convert_integral: [
        //   { required: true, message: "兑换所需积分", trigger: "blur" }
        // ]
      },
      columns: [
        {
          title: "活动名称",
          key: "activity_name"
        },
        {
          title: "积分倍数",
          key: "integral_times"
        },
        {
          title: "活动范围",
          render: (h, params) => {
            if (params.row.activity_range === 1) {
              return h("div", [
                h(
                  "span",

                  "购买文章"
                )
              ]);
            } else if (params.row.activity_range === 2) {
              return h("div", [
                h(
                  "span",

                  "充值"
                )
              ]);
            } else {
              return h("div", [
                h(
                  "span",

                  "全部"
                )
              ]);
            }
          }
        },
        {
          title: "活动时间",
          key: "activity_time",
          width: 300,
          // render: (h, params) => {
          //   return h("div", [
          //     h(
          //       "span",

          //       params.row.start_time + " 至 " + params.row.end_time
          //     )
          //   ]);
          // }
        },
        {
          title: "操作",
          align: 'center',
          render: (h, params) => {
            return h("div", [
             /* h(
                "span",
                {
                  class: {
                    btn_edit: true
                  },
                  on: {
                    click: () => this.addEdit(params)
                  }
                },
                "编辑"
              ),
              h("i", {
                class: {
                  sline: true
                }
              }),*/
              h(
                "span",
                {
                  class: {
                    btn_del: true
                  },
                  on: {
                    click: () => this.handleDel(params)
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  mounted() {
    this.handleQuery();
  },
  methods: {
    //日期范围
    handleDateChange(val) {
      if (val[0]) {
        this.modalForm.start_time = val[0];
        this.modalForm.end_time = val[1];
      } else {
        this.modalForm.start_time = "";
        this.modalForm.end_time = "";
      }
    },
    // 重置
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.handleQuery();
    },
    // 查询
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      this.tableLoading = true;
      this.$api.integralEditList({}).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.list;
          this.tableLoading = false;
          this.total = res.data.total_row;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    // 删除
    handleDel(params) {
      this.$Modal.confirm({
        render: h => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true
                }
              },
              "删除活动"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true
                }
              },
              `确定删除该活动吗？`
            )
          ]);
        },
        onOk: () => {
          this.$api
            .integralEditDel({
              id: params.row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                this.handleQuery();
              } else {
                this.$Message.error(res.msg);
              }
            });
        }
      });
    },
    handleModalSubmit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          // this.modalForm.cash_money = this.modalForm.cash_money - 0;
          // this.modalForm.convert_integral = this.modalForm.convert_integral - 0;
          // this.modalForm.use_range = this.modalForm.use_range - 0;
          this.modalLoading = true;
          if (this.modalTitle === "添加积分活动") {
            this.$api.integralEditAdd({ ...this.modalForm }).then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                this.modalVisibile = false;
                this.modalLoading = false;

                this.handleQuery();
                this.handleCancel();
              } else {
                this.$Message.error(res.msg);
                this.modalForm.sort = this.modalForm.sort + "";
              }
              this.modalLoading = false;
            });
          } else {
            this.$api.integralEditSet({ ...this.modalForm }).then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                this.modalVisibile = false;
                this.modalLoading = false;

                this.getTableData();
                this.handleCancel();
              } else {
                this.$Message.error(res.msg);
                this.modalForm.sort = this.modalForm.sort + "";
              }
              this.modalLoading = false;
            });
          }
        }
      });
    },
    //活动时间设置提交
    handleModalSubmit_time() {
      this.modalLoading = true;
      this.$api.setActivityTime({ ...this.modalFormTime }).then(res => {
        if (res.code === 0) {
          this.$Message.success(res.msg);
          this.modalVisibileTime = false;
          this.modalLoading = false;
          this.handleQuery();
          this.handleCancel();
        } else {
          this.$Message.error(res.msg);
          // this.modalForm.sort = this.modalForm.sort + "";
        }
        this.modalLoading = false;
      });
    },
    // 弹框取消
    handleCancel() {
      this.$refs.modalForm.resetFields();
      this.modalForm = Object.assign({}, this.modalForm1);
      this.modalVisibile = false;
      this.date = [];
    },
    //编辑和添加
    addEdit(params) {
      if (params) {
        this.modalTitle = "编辑积分活动";
        this.modalForm = Object.assign({}, this.modalForm1);
        this.modalForm.activity_name = params.row.activity_name;
        this.modalForm.integral_times = params.row.integral_times + "";
        //需要先赋值再覆盖
        this.date=['2020-03-04 00:00:00','2020-03-05 00:00:00']    
        this.date[0]=this.modalForm.start_time = params.row.start_time;
         this.date[1]=this.modalForm.end_time = params.row.end_time;            
        this.modalForm.activity_range = params.row.activity_range + "";

        this.modalForm.id = params.row.id;

        // this.modalForm
        this.modalForm.use_range = params.row.use_range + "";
      } else {
        this.modalTitle = "添加积分活动";
      }
      this.modalVisibile = true;
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-form-item {
  margin-bottom: 0;
}

.checkReset:first-child {
  margin-right: 8px;
}

.ivu-modal-footer {
  border-top: none !important;
}

.shadowLine {
  width: 660px;
  height: 1px;
  background: #e9e9e9;
  margin: 24px 0;
}

.wechartBox {
  width: 282px;
  border: 1px solid #dce1e6;
  border-radius: 4px;
  line-height: 32px;
  padding-left: 12px;

  span {
    width: 74px;
    text-align: center;
    border-left: 1px solid #dce1e6;
    cursor: pointer;
  }
}

/deep/ .ivu-upload-drag {
  border: none;
  background: transparent;
}

/deep/textarea.ivu-input {
  height: 115px;
}

.playFont {
  color: #8a9299;
}

.boldTitle {
  color: #000;
  font-weight: bold;
  font-size: 14px;
}

.graybg {
  width: 724px;
  height: 12px;
  background: #f0f3f5;
  position: relative;
  left: -32px;
  margin-bottom: 24px;
  margin-top: 8px;
}

.shadowTitleClick span {
  cursor: pointer;
}

/deep/ .table_pic {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: block;
  cursor: pointer;
}
/deep/.btn_del {
  padding-left: 0;
}
</style>
